import {Pipe, PipeTransform} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {ReminderType} from '../supervision-management/compliance-items/compliance-item/enums/reminder-type.enum';
import {UnitOfMeasure} from '../supervision-management/compliance-items/compliance-item/enums/unit-of-measure.enum';
import {ComplianceItemService} from '../services/compliance-item.service';
import { ReminderFor } from '../supervision-management/compliance-items/compliance-item/enums/reminder-for-type.enum';
@Pipe({
    name: 'itemReminderSummary',
    pure: false
})
export class ItemReminderSummaryPipe implements PipeTransform {
    constructor(private complianceItemService: ComplianceItemService) {}

    transform(item: UntypedFormGroup): string {
        let reminderType: AbstractControl = item.get('ReminderType');
        let retval = '';

        if (item.get('ReminderFor') && item.get('ReminderFor').value && item.get('ReminderFor').value.toString()  === ReminderFor.APPROVAL.toString()) {
            retval = this.approval(item)
        } else {
            switch (Number(reminderType.value)) {
                case ReminderType.EXPIRED:
                    retval = this.expiring(item);
                    break;
    
                case ReminderType.NORMAL:
                    retval = this.normal(item);
                    break;
            }
        }

        return retval;
    }

    private expiring(reminder: UntypedFormGroup): string {
        let retval = '';

        retval += reminder.get('Frequency').value;
        retval += this.complianceItemService.unitOfMeasure(reminder.get('UOM').value);
        retval += reminder.get('Frequency').value !== 1 ? 's' : '';
        retval += ' after the End Date';

        return retval;
    }

    private normal(reminder: UntypedFormGroup): string {
        let retval = '';

        retval += reminder.get('Frequency').value;
        retval += this.complianceItemService.unitOfMeasure(reminder.get('UOM').value);
        retval += reminder.get('Frequency').value !== 1 ? 's' : '';
        retval += ' prior to the End Date';

        return retval;
    }

    private approval(reminder: UntypedFormGroup): string {
        let retval = '';

        retval += 'Every '
        retval += reminder.get('Frequency').value !== 1 ? reminder.get('Frequency').value : '';
        retval += this.complianceItemService.unitOfMeasure(reminder.get('UOM').value);
        retval += reminder.get('Frequency').value !== 1 ? 's' : '';
        retval += ' Until Item is Approved';

        return retval;
    }
}